import { Button, Typography, Alert, AlertTitle } from "@mui/material";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import messages from "../../../../utils/messages";
import serviceFaturaInstalacao from "../../../../services/serviceFaturaInstalacao";
import { toast } from "react-toastify";
import { useState } from "react";
import { Loader } from "./styles";
export interface IDialogProps {
    open: boolean;
    onClose?: any;
    data: any;
    onSuccess: () => void;
}

export default function DialogRecalculate({ open, onClose, data, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const handleRequest = (tipoRecalculo: string) => {
        setDisable(true);

        serviceFaturaInstalacao
            .recalculate(data.faturaInstalacaoID || data, tipoRecalculo)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    const isEdited = data?.editado === "Sim";

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Recalcular fatura
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            // color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid item xs={12}>
                        {isDisable && (
                            <Loader>
                                <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                            </Loader>
                        )}
                    </Grid>
                    
                    {isEdited && (
                        <Alert severity="error" sx={{ mb: 2, backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', '& .MuiAlert-icon': { color: '#f39c12' } }}>
                            <AlertTitle sx={{ fontWeight: 'bold', color: '#d68910' }}>⚠️ Atenção</AlertTitle>
                            Esta fatura de instalação já sofreu edição manual.
                        </Alert>
                    )}
                    
                    <Typography sx={{ mb: 3 }}>
                        {isEdited 
                            ? "Escolha o tipo de recálculo que deseja aplicar:" 
                            : "Tem certeza que deseja recalcular esta fatura?"
                        }
                    </Typography>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px", gap: "12px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    
                    {isEdited ? (
                        <>
                            <Button
                                onClick={() => handleRequest("PARCIAL")}
                                color="primary"
                                variant="contained"
                                disabled={isDisable}
                                style={{ width: "159px", height: "44px" }}
                            >
                                Parcial
                            </Button>
                            <Button
                                onClick={() => handleRequest("TOTAL")}
                                color="primary"
                                variant="contained"
                                disabled={isDisable}
                                style={{ width: "159px", height: "44px" }}
                            >
                                Total
                            </Button>
                        </>
                    ) : (
                        <Button
                            onClick={() => handleRequest("TOTAL")}
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Confirmar
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
}
